import { ShiftDirectionEnum } from '../settings.constants';

type ShiftDirectionType = ShiftDirectionEnum.DaysAfter | ShiftDirectionEnum.DaysBefore;

interface IDefaultDeadline {
  daysOffset: number;
  time: string;
}

interface IDefaultDeadlineSplit {
  shiftValue: number;
  shiftDirection: ShiftDirectionType;
  hour: number;
  minute: string;
  period: string;
}

interface ICustomDeadline {
  deadlineDateTime?: string;
  dateTime?: string;
  changeable?: boolean;
  restorable?: boolean;
}

interface ICustomDeadlineSplit extends ICustomDeadline {
  hour: number;
  minute: string;
  period: string;
  date: Date;
  selectedMonth?: Date;
  restoredDefaultDeadline?: boolean;
}

interface ICustomDeadlineUpdate {
  dateTime: string;
  year: string;
  month: string;
  restoredDefaultDeadline: boolean;
}

interface IMessage {
  subject: string;
  text: string;
  isMessageDefault?: boolean;
  notificationType: NotificationType;
}

interface IDefaultNotification {
  defaultNotificationId: number;
  defaultNotificationDaysOffset: number;
  time: string;
  notificationMessage: string;
  notificationSubject: string;
  notificationSubjectDefault?: boolean;
  notificationMessageDefault?: boolean;
  type: NotificationType;
}

interface INotificationSplit {
  id?: number;
  hour: number;
  minute: string;
  period: string;
  daysOffset: number;
  type: NotificationType;
}

interface INotificationMessage {
  message: string;
  subject: string;
  type: NotificationType;
}

interface ICustomNotificationMessage extends INotificationMessage {
  subjectDefault?: boolean;
  messageDefault?: boolean;
}

interface ICustomNotificationDateTimes {
  daysOffset: number;
  time: string;
  type: NotificationType;
}

interface ICustomNotification {
  deadlineDate?: string;
  changeable?: boolean;
  restorable?: boolean;
  customNotificationDateTimes: ICustomNotificationDateTimes[];
  messages: ICustomNotificationMessage[];
}

interface ICustomNotificationsSplitData {
  notifications: INotificationSplit[];
  messages: IMessage[];
  restorable: boolean;
  changeable: boolean;
  deadlineDate: string;
}

enum NotificationType {
  DEADLINE = 'DEADLINE',
  OVERVIEW = 'OVERVIEW'
}

export {
  ShiftDirectionType,
  IDefaultDeadline,
  IDefaultDeadlineSplit,
  ICustomDeadline,
  ICustomDeadlineSplit,
  ICustomDeadlineUpdate,
  IMessage,
  IDefaultNotification,
  INotificationSplit,
  INotificationMessage,
  ICustomNotification,
  ICustomNotificationsSplitData,
  NotificationType,
  ICustomNotificationMessage,
  ICustomNotificationDateTimes
};
